"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Plyr = require("plyr");
document.addEventListener("DOMContentLoaded", () => {
    const videoContainers = document.querySelectorAll(".content__plyr");
    if (videoContainers.length === 0)
        return;
    videoContainers.forEach(video => {
        new Plyr(video, {
            controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "settings", "fullscreen"],
            autoplay: true
        });
    });
    document.querySelectorAll(".content__video").forEach(videoContainer => {
        const player = videoContainer.querySelector(":scope > div");
        if (player && !player.classList.length) {
            player.classList.add("content__plyr");
        }
    });
});
